<script>
import BaseChart from '@/components/common/BaseChart.vue';
import chartColors from '@/components/common/chart-colors';
import { format as formatNumber } from '@/utils/number';

const tooltipItemTemplate = item => `<div>
                <strong style="color:${item.color}">
                  ${item.name}:
                </strong>
                <strong style="font-size: 110%;">
                  ${formatNumber(Math.round(item.y))}
                </strong>
              </div>`;

const baseConfig = {
  tooltip: {
    shared: true,
    useHTML: true,
    borderWidth: 0,
    backgroundColor: null,
    formatter() {
      return this.series?.data
        ?.map?.(data => tooltipItemTemplate(data, this.key === data.name))
        .join('');
    },
    followTouchMove: false,
    followPointer: false,
  },
  credits: { enabled: false },
  colors: chartColors,
  plotOptions: {
    series: {
      borderWidth: 0,
      colorByPoint: true,
      type: 'pie',
      size: '100%',
      dataLabels: { enabled: false },
    },
  },
};

export default {
  name: 'PieChart',
  components: {
    BaseChart,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    titleHtml: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 200,
    },
  },
  computed: {
    config() {
      return {
        ...baseConfig,
        chart: {
          type: 'pie',
          height: this.size,
          width: this.size,
          spacing: [0, 0, 0, 0],
        },
        title: {
          useHTML: Boolean(this.titleHtml),
          text: `<div class="pie-chart__title">
                   ${this.titleHtml || this.title}
                </div>`,
          align: 'center',
          verticalAlign: 'middle',
        },
        series: [
          {
            size: '70%',
            innerSize: '80%',
            showInLegend: false,
            enableMouseTracking: false,
            data: [1],
            animation: false,
            colors: ['#F1F2F9'],
          },
          {
            type: 'pie',
            innerSize: '70%',
            data: this.values?.map((val, i) => [this.labels[i], val]),
          },
        ],
      };
    },
  },
};
</script>

<template>
  <div class="pie-chart">
    <BaseChart ref="chart" :options="config" />
  </div>
</template>

<style lang="scss">
.pie-chart {
  flex-shrink: 0;
  // width: 200px;
  &__title {
    text-align: center;
    // width: 109px;
    // height: 109px;
    // border: 10px solid #f1f2f9;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .highcharts-title {
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
    width: 40%;
  }

  .highcharts-tooltip > span {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: rgba(50, 50, 93, 0.55) 0px 2px 5px -1px,
      rgba(0, 0, 0, 1) 0px 1px 3px -1px;
    padding: 8px;
  }
}
</style>
